import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { TreeSelect, Tooltip } from "antd";
import BunkeyAPI from "../../api/BunkeyAPI";

export class Breadcrumb extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folderId: null,
      data: []
    };
  }

  async componentDidMount() {
    const result = await this.handleGetData();
    this.setState({
      data: result.map(r => {
        return {
          id: r._id,
          pId: "root",
          value: r._id,
          title:
            r.name.length > 26 ? (
              <Tooltip title={r.name} placement="left">
                {r.name.slice(0, 26)}...
              </Tooltip>
            ) : (
              r.name
            )
        };
      })
    });
  }

  componentDidUpdate(prevProps) {
    const { clear } = this.props;
    if (prevProps.clear !== clear) {
      this.setState({
        folderId: null
      });
    }
  }

  handleGetData = async (parentId = null) => {
    const { workClient, root } = this.props;
    let preData = [];
    const parentIdValue = parentId ? parentId : root;

    const resp = await BunkeyAPI({
      url: `/clients/${workClient}/breadcrumb/childs/${parentIdValue}`,
      method: "GET"
    });

    if (resp && resp.data && resp.data.length > 0) {
      preData = resp.data[0].childs;
    }

    return preData;
  };

  onChange = item => {
    this.props.handleFolderSelect(item);
    this.setState({
      folderId: item
    });
  };

  onLoadData = treeNode => {
    return new Promise(async resolve => {
      const currentId = treeNode.props.value;
      const result = await this.handleGetData(currentId);
      this.setState({
        data: this.state.data.concat(
          result.map(r => {
            return {
              id: r._id,
              pId: currentId,
              value: r._id,
              title:
                r.name.length > 26 ? (
                  <Tooltip title={r.name} placement="left">
                    {r.name.slice(0, 26)}...
                  </Tooltip>
                ) : (
                  r.name
                )
            };
          })
        )
      });

      resolve();
    });
  };

  render() {
    const { title, placeholder, changeFolder, isMultiple } = this.props;
    const { folderId, data } = this.state;
    return (
      <React.Fragment>
        {data && (
          <React.Fragment>
            <span>{title}</span>
            <TreeSelect
              treeDataSimpleMode
              disabled={changeFolder}
              value={folderId}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder={placeholder}
              onChange={this.onChange}
              loadData={this.onLoadData}
              multiple={isMultiple}
              treeData={data}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    breadcrumb: state.client.breadcrumb,
    newMatrix: state.group.newMatrix,
    root: state.client.root,
    workClient: state.client.workclient
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Breadcrumb))
);
